export default class campaignContentPreview {
    constructor() {
        return {
            restrict: 'E',
            replace: true,
            template: require('../../../../views/campaign/partials/campaign-content-preview.html'),
            scope: {
                campaign: '=',
                view: '='
            },
            controller: [
                '$scope', '$element', '$attrs', 'Rest', 'Language', '$q',
                (scope, element, attr, Rest, Language, $q) => {

                scope.showPreview = false;
                scope.language = null;

                var getEmailLanguage = () => {
                    var deferred = $q.defer();
                    if (scope.campaign.emails) {
                        if (scope.campaign.emails[0].language_id != 0) {
                            Language.find(scope.campaign.emails[0].language_id).then((language) => {
                                scope.language = language;
                                deferred.resolve();
                            });
                        } else {
                            deferred.resolve();
                        }
                    } else {
                        deferred.resolve();
                    }

                    return deferred.promise;
                };

                scope.getHtmlSource = () => {
                    return "campaign/" + scope.campaign.id + "/htmlContent";
                };

                scope.togglePreview = () => {
                    scope.showPreview = !scope.showPreview;
                    scope.showPreview ? $('body').css('overflow-y', 'hidden') : $('body').css('overflow-y', 'inherit');

                    if (scope.showPreview) {
                        getEmailLanguage().then(() => {
                            var htmlSource = scope.getHtmlSource();

                            Rest.one(htmlSource).get().then((res) => {
                                if (scope.language) {
                                    element.find("#previewHtml").contents().find('html').html(scope.parseLanguageBlocks(res, scope.language.code));
                                } else {
                                    element.find("#previewHtml").contents().find('html').html(res);
                                }
                            });
                        });
                    }
                };

                scope.disableClicks = () => {
                    $('#previewHtml').contents().click('a', (e) => {
                        e.preventDefault();
                    });
                }

                scope.parseLanguageBlocks = (htmlContent, language) => {
                    var jHtmlObject = $(htmlContent);
                    var wrapper = $("<div>").append(jHtmlObject);

                    $(wrapper).find('[data-language]').each(() => {
                        var blockLanguage = $(this).attr('data-language');

                        if (blockLanguage && blockLanguage != language) {
                            $(this).hide();
                        }
                    });

                    return wrapper.html();
                }


                // sms campaign preview

                scope.previewSMSContent = () => {
                    scope.$emit('event:show-sms-text', scope.campaign);
                }
            }]
        }
    }
}
